// no itx for this file
import SettingsPage from "../components/SettingsPane/SettingsPage";
import { EstadaPerformance, PerformanceItem } from "../performance/PerfomanceItem";
import { noItx } from "../translationItx/itx";

export default function SettingPagePerformance(props: { handler: string }) {
  function PerformanceList() {
    function PerformanceRow(props: { item: PerformanceItem }) {
      const { item } = props;
      return (
        <tr>
          <td>
            <div>{item.name}</div>
          </td>
          <td>
            <div>{item.counter}</div>
          </td>
          <td>
            <div>{item.averageMS()} </div>
          </td>
          <td>
            <div>{item.maxMS} </div>
          </td>
        </tr>
      );
    }

    const loggerRows = Array.from(EstadaPerformance.itemsSortByName()).map((item) => {
      return <PerformanceRow key={item.name} item={item} />;
    });

    return (
      <div>
        <table style={{ width: "max-content" }}>
          <thead>
            <tr>
              <th>{noItx("Name")}</th>
              <th>{noItx("Counter")}</th>
              <th>{noItx("Average (ms)")}</th>
              <th>{noItx("Max (ms)")}</th>
            </tr>
          </thead>
          <tbody>{loggerRows}</tbody>
        </table>
        <div style={{ position: "absolute", top: "0px", right: "0px" }}>
          <button
            className="button"
            onClick={(ev) => {
              // Implicitly closes the settings screen
              ev.stopPropagation();
              EstadaPerformance.items.forEach((item) => {
                item.reset();
              });
            }}
          >
            {noItx("Reset")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <SettingsPage
      handler="/settings/performance" // no itx
    >
      <PerformanceList />
    </SettingsPage>
  );
}
